export default "__VITE_ASSET__B_8wjTKW__"